import React from 'react'
import PropTypes from 'prop-types'

import * as Content from '../reducers/Content'

const FolderNode = (props) => {
  const { node } = props
  const icon = Content.displayIcon(node, false)
  const title = Content.displayTitle(node, false)
  return (
    <div className="folderNode">
      <div className="folderNodeContent">
        <div className="folderNodeIcon">{icon}</div>
        <div className="folderNodeTitleContainer">
          <div className="folderNodeTitle">{title}</div>
        </div>
      </div>
      <div className="folderNodeArrow">
        <img
          className="folderNodeArrowText"
          src="/arrow_forward.svg"
          alt=""
          draggable="false"
        />
      </div>
    </div>
  )
}

FolderNode.propTypes = {
  node: PropTypes.shape({
    icon: PropTypes.string,
    title: PropTypes.string,
  }),
}

export default FolderNode
